<label [for]="name()" class="flex min-h-[32px] w-full flex-col gap-1">
  @if (!labelTemplate()) {
    @if (label()) {
      <span>{{ label() }}</span>
    }
  } @else {
    <ng-container
      [ngTemplateOutlet]="labelTemplate()"
      [ngTemplateOutletContext]="{ $implicit: label() }" />
  }

  <div
    id="input-container"
    [ngClass]="{
      'border-error has-[:focus]:ring-error': showError(),
      'border-theme-secondary-gray has-[:focus]:ring-theme-secondary-gray': !showError(),
      '!bg-theme-gray-400 !cursor-not-allowed opacity-60': disabled(),
    }"
    class="autogrow-input-container">
    <ng-content></ng-content>
    <div
      class="autogrow-text-field focus:ring-1"
      [ngClass]="{ 'cursor-not-allowed': disabled() }"
      contenteditable
      [id]="name()"
      [textContent]="value()"
      [isFocused]="isFocused()"
      (blur)="onInput($event)"
      (keydown.enter)="$event.preventDefault()"
      (click)="clicked.emit()"></div>
  </div>
  @if (showError()) {
    @for (error of validationErrors(); track error) {
      <span class="text-error">{{ error.message }}</span>
    }
  }
</label>
